import { TaskSheetInputType } from '@/enum'
import type { IAnswerValue, ITaskSheetInput } from '@/interfaces'
import AnswerValue from './AnswerValue'
import { DEFAULT_JOB_START_TIME, DEFAULT_TEMPLATE_INPUT_IS_OPTIONAL } from '@/utils/constants'
import {
  ChecklistAnswerValue,
  InputValue,
  type InputValue as IInputValueType
} from '@/models/task-sheets'

class TaskSheetInput implements ITaskSheetInput {
  recordId: string

  creatorId: string

  updaterId: string

  title: string

  description: string

  order: number

  isReadonly: boolean

  isOptional: boolean

  inputType: TaskSheetInputType

  answers: IAnswerValue[]

  choiceOptions: { recordId: string; value: string }[]

  items?: IInputValueType[]

  isCompleted?: boolean

  useAsHeader: boolean

  constructor(input?: any, isGetRequest?: boolean) {
    this.recordId = input?.recordId
    this.creatorId = input?.creatorId
    this.updaterId = input?.updaterId
    this.title = input?.title
    this.description = input?.description
    this.order = input?.order
    this.isReadonly = !!input?.isReadonly
    this.isOptional =
      input?.isOptional ??
      ([TaskSheetInputType.BOOLEAN, TaskSheetInputType.CHECKLIST].includes(input?.inputType) ||
        DEFAULT_TEMPLATE_INPUT_IS_OPTIONAL)
    this.inputType = input?.inputType
    this.isCompleted = input?.isCompleted
    if (input?.inputType === TaskSheetInputType.CHECKLIST) {
      this.answers = input?.answers?.map((answer: any) => new ChecklistAnswerValue(answer)) ?? []
    } else {
      this.answers = input?.answers?.map((answer: any) => new AnswerValue(answer)) ?? []
    }
    if (isGetRequest && input?.inputType === TaskSheetInputType.STRING && input?.isReadonly) {
      this.inputType = TaskSheetInputType.LABEL
    } else if (
      !isGetRequest &&
      input?.inputType === TaskSheetInputType.LABEL &&
      input?.isReadonly
    ) {
      this.inputType = TaskSheetInputType.STRING
    }
    this.choiceOptions = []
    if (input?.inputType === TaskSheetInputType.TIME && !this.answers.length) {
      this.answers = [new AnswerValue({ value: DEFAULT_JOB_START_TIME })]
    }
    if (
      [TaskSheetInputType.SINGLE_CHOICE, TaskSheetInputType.MULTI_CHOICE].includes(input?.inputType)
    ) {
      this.choiceOptions = input.choiceOptions.map((item: any) => new InputValue(item)) ?? []
    }
    if (input?.inputType === TaskSheetInputType.CHECKLIST) {
      this.items = input?.items?.map((item: any) => new InputValue(item)) ?? []
    }
    this.useAsHeader = !!input?.useAsHeader
  }
}

export default TaskSheetInput
